export default {
  QUEST_HELP_QUESTID: 'c-greta-help-hub',
  USER_ID: 'u-a179a548-b12c-4b50-9cd0-e435a1fda2f2',
  APIKEY: 'k-64eec171-6a46-4883-a028-0cd35a71d84b',
  TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1LWExNzlhNTQ4LWIxMmMtNGI1MC05Y2QwLWU0MzVhMWZkYTJmMiIsImlhdCI6MTc1MTQ4MjI4NiwiZXhwIjoxNzU0MDc0Mjg2fQ.NekMXT5rFx9VLAZcbb9DdT7T96HkAWlLqpQFE6xG8eg',
  ENTITYID: 'e-0ff41c70-d88f-4e3c-a29c-1e98175116f8',
  PRIMARY_COLOR: '#2563eb' // Extracted from your blue-600 theme
};